<template>
    <v-table
        class="table-data"
        fixed-header>
        <thead>
        <tr>
            <th v-for="item in headers"
            :key="item" class="text-left">
            {{item}}
            </th>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in orders"
          :key="item._id"
          @click="openDrawer(item)">
          <td>{{formatTimestamp(item.created) }}</td>
          <td>{{item.folio}}</td>
          <td>{{item.terminal.name }}</td>
          <td>{{getProducts(item.products)}}</td>
          <td>{{getMethod(item.method) }}</td>
          <td>{{item.discount}}%</td>
          <td>${{item.amount }}</td>
          <td>{{getStatus(item.status)}}</td>
        </tr>
        </tbody>
    </v-table>

    <order-drawer ref="drawerOrder"/>

</template>

<script>
import dateTransform from '@/utils/dateTransform'
import OrderDrawer from '../drawers/OrderDrawer.vue'

export default {
  name: 'CommerciaVueOrdersTable',
  components: {
    OrderDrawer

  },
  emits: ['refreshList'],
  props: {
    orders: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      headers: ['Fecha',
        'No. Orden',
        'POS',
        'Cant. Productos',
        'Método',
        'Descuento',
        'Monto',
        'Estatus']
    }
  },

  methods: {
    refresh () { this.$emit('refreshList') },

    formatTimestamp (timestamp) {
      return dateTransform.timestampToFormat(timestamp)
    },

    getProducts (products) {
      return products.reduce((total, product) => total + (product.quantity || 0), 0)
    },

    openDrawer (item) {
      this.$refs.drawerOrder.show(item)
    },

    getMethod (method) {
      switch (method) {
        case 'cash':
          return 'Efectivo'
        case 'transfer':
          return 'Transferencia'
        case 'debit':
          return 'Debito'
        case 'credit':
          return 'Credito'
        case 'open':
          return 'Abierto'
        default:
          return 'Combinado'
      }
    },

    getStatus (status) {
      switch (status) {
        case 'new':
          return 'Nueva'
        case 'preparing':
          return 'Preparando'
        case 'ready':
          return 'Lista para entrega'
        case 'delivered':
          return 'Entregada'
        case 'canceled':
          return 'Cancelada'
      }
    },

    getPaymentMethods (payments) {
      const methodMap = {
        cash: 'Efectivo',
        transfer: 'Transferencia',
        debit: 'Débito',
        credit: 'Crédito'
      }
      const uniqueMethods = [...new Set(
        payments
          .filter(p => !p.canceled) // excluir cancelados si aplica
          .map(p => methodMap[p.method])
          .filter(Boolean) // evita undefined si hay métodos no mapeados
      )]
      return uniqueMethods.join(', ')
    }

  }
}
</script>
